import React from 'react';
import { Inmate } from '@reliance/types/models/Inmate';

type MarkAllReadButtonProps = {
  inmate?: Inmate;
  reading?: boolean;
  onRead?: () => void;
  loading?: boolean;
};

const MarkAllReadButton: React.FC<MarkAllReadButtonProps> = (props) => {
  const { inmate, reading = false, onRead, loading = false } = props;

  if (loading || !inmate) {
    return null;
  }

  return (
    <div className="d-flex justify-content-end mb-3 mt-3">
      <button
        type="button"
        className="btn btn-primary"
        disabled={reading}
        onClick={onRead}>
        Mark All As Read
      </button>
    </div>
  );
};

export default MarkAllReadButton;
